/* KOA — colour name on hover/focus for product-card swatches.
   Writes the hovered swatch's existing .sr-only name into the card's
   .koa-swatch-count line and restores the count on leave. Text-only:
   no positioning and no vendor style overrides — a position change here
   re-anchors Prestige's disabled-swatch diagonal (see koa.css note). */
(function () {
  function countFor(swatch) {
    var card = swatch.closest('product-card');
    return card ? card.querySelector('.koa-swatch-count') : null;
  }

  function show(swatch) {
    var countEl = countFor(swatch);
    if (!countEl) return;
    var name = swatch.querySelector('.sr-only');
    if (!name) return;
    if (!countEl.dataset.koaCount) countEl.dataset.koaCount = countEl.textContent;
    var label = name.textContent.trim();
    if (swatch.classList.contains('is-disabled')) label += ' — sold out';
    countEl.textContent = label;
  }

  function restore(swatch) {
    var countEl = countFor(swatch);
    if (countEl && countEl.dataset.koaCount) countEl.textContent = countEl.dataset.koaCount;
  }

  function swatchFromInput(input) {
    if (!input.id || typeof input.matches !== 'function') return null;
    if (!input.matches('input.sr-only[type="radio"]')) return null;
    return document.querySelector('label[for="' + CSS.escape(input.id) + '"].color-swatch');
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (swatch) show(swatch);
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (swatch) restore(swatch);
  });

  /* Keyboard parity: the radio input is the focusable element, not the label. */
  document.addEventListener('focusin', function (e) {
    var swatch = swatchFromInput(e.target);
    if (swatch) show(swatch);
  });

  document.addEventListener('focusout', function (e) {
    var swatch = swatchFromInput(e.target);
    if (swatch) restore(swatch);
  });
})();

/* KOA — sold-out restock block sync (buy-buttons.liquid).
   Prestige flips the ATC to "Sold out" client-side without re-rendering the
   area after the product form, so the server-rendered restock block goes
   stale on variant switches. Prestige dispatches a bubbling `variant:change`
   with the full variant object; we toggle the block and keep its colour tag
   and return_to pointing at the variant the shopper is actually looking at. */
(function () {
  function handleize(value) {
    return String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  document.addEventListener('variant:change', function (e) {
    var block = document.getElementById('koa-restock');
    var variant = e.detail && e.detail.variant;
    if (!block || !variant) return;

    /* Ignore quick-buy/related-product forms — only the form sharing the
       block's section drives it. */
    var form = e.target;
    if (form.closest && block.closest('.shopify-section') !== form.closest('.shopify-section')) return;

    if (variant.available) {
      block.hidden = true;
      return;
    }
    block.hidden = false;

    var idx = parseInt(block.dataset.colourIndex, 10);
    var colour = idx >= 0 ? variant['option' + (idx + 1)] : '';

    var tagsInput = block.querySelector('input[name="contact[tags]"]');
    if (tagsInput) {
      var tags = 'restock-request,restock:' + block.dataset.productHandle;
      if (colour) tags += ',restock-colour:' + handleize(colour);
      tagsInput.value = tags;
    }

    var returnTo = block.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + '?variant=' + variant.id + '&customer_posted=true#koa-restock';
  });
})();

/* KOA — embroidery add-on (snippets/koa-embroidery.liquid).
   Shopify Basic has no checkout fields and no Cart Transform price-merge, so
   the $20 embroidery charge cannot be folded into the top's own line. Instead:
     - the TOP carries the spec (name/colour/font/placement) as line item
       properties, submitted with it by the product form;
     - when the theme fires `variant:add` for an embroidered top, we add the
       companion $20 product as its own line, quantity matched, tagged with the
       same hidden `_emb` token so we can pair them.
   A cart reconcile keeps each charge line's quantity equal to its top's, and
   removes the charge if the top is gone — no orphan $20 lines.
   The `<fieldset>` is disabled+hidden until the toggle is on, so a normal order
   submits no embroidery properties at all. */
(function () {
  var CHARGE_HANDLE = 'embroidery-scrub-tops';

  function token() {
    return 'emb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }

  customElements.define('koa-embroidery', class extends HTMLElement {
    connectedCallback() {
      this.variantWhite = parseInt(this.dataset.chargeVariantWhite, 10);
      this.variantBlack = parseInt(this.dataset.chargeVariantBlack, 10);
      this.toggle = this.querySelector('input[name="properties[Embroidery]"]');
      this.fields = this.querySelector('.koa-emb__fields');
      this.tokenInput = this.querySelector('.koa-emb__token');
      this.nameInput = this.querySelector('input[name="properties[Embroidery name]"]');
      this.threadSelect = this.querySelector('select[name="properties[Thread colour]"]');
      this.form = this.closest('form');
      this._pending = null;
      if (!this.toggle || !this.fields || !this.form) return;

      this.toggle.addEventListener('change', this.onToggle.bind(this));
      /* Capture phase, no preventDefault: the theme still handles the add. We
         only record that this form's next add should carry a charge. */
      this.form.addEventListener('submit', this.onSubmit.bind(this), true);
      document.addEventListener('variant:add', this.onVariantAdd.bind(this));
    }

    onToggle() {
      var on = this.toggle.checked;
      this.fields.disabled = !on;
      this.fields.hidden = !on;
      this.tokenInput.value = on ? token() : '';
    }

    onSubmit() {
      /* Native validation (required + maxlength) runs before submit; if the
         form is invalid the browser blocks it and variant:add never fires, so
         we never arm a charge for an incomplete order. */
      if (!this.toggle.checked || !this.form.checkValidity()) {
        this._pending = null;
        return;
      }
      /* Prestige renders the quantity selector as a separate block OUTSIDE the
         product form, so read it from the host section, not the form. */
      var section = this.closest('.shopify-section') || document;
      var qtyInput = section.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var thread = this.threadSelect ? this.threadSelect.value : '';
      this._pending = {
        variant: thread === 'Black' ? this.variantBlack : this.variantWhite,
        token: this.tokenInput.value,
        name: this.nameInput ? this.nameInput.value.trim() : '',
        qty: qty
      };
    }

    onVariantAdd() {
      if (!this._pending) return;
      var p = this._pending;
      this._pending = null;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: p.variant,
            quantity: p.qty,
            properties: p.name ? { _emb_ref: p.token, 'For': p.name } : { _emb_ref: p.token }
          }]
        })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(function (err) { console.warn('[koa-embroidery] charge add failed', err); });
    }
  });

  /* Cart reconcile: pair top lines (properties._emb) with charge lines
     (handle + properties._emb_ref). Match each charge's quantity to the sum of
     its paired tops; remove charges whose top is gone.
     Runs on cart mutation (the drawer's AJAX path) AND on page load — the cart
     PAGE removes a line via full navigation, which fires no cart:change, so the
     on-load pass is the safety net that clears an orphaned $20 line. */
  var busy = false;
  var suppressUntil = 0;

  function onCartPage() {
    return location.pathname.replace(/\/$/, '').split('?')[0].endsWith('/cart') ||
      location.pathname.replace(/\/$/, '') === '/cart';
  }

  function reconcile(opts) {
    opts = opts || {};
    if (busy || Date.now() < suppressUntil) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wanted = {}; /* token -> total top quantity */
        cart.items.forEach(function (it) {
          var t = it.properties && it.properties._emb;
          if (t) wanted[t] = (wanted[t] || 0) + it.quantity;
        });

        var ops = [];
        cart.items.forEach(function (it) {
          if (it.handle !== CHARGE_HANDLE) return;
          var ref = it.properties && it.properties._emb_ref;
          var desired = ref ? (wanted[ref] || 0) : it.quantity;
          if (desired !== it.quantity) ops.push({ id: it.key, quantity: desired });
        });

        if (!ops.length) {
          /* Clean cart — clear the reload guard so a future orphan can heal. */
          try { sessionStorage.removeItem('koaEmbReloaded'); } catch (e) {}
          busy = false;
          return;
        }

        /* Apply sequentially; suppress the echo our own changes produce. */
        var chain = Promise.resolve();
        ops.forEach(function (op) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: op.id, quantity: op.quantity })
            });
          });
        });
        return chain.then(function () {
          suppressUntil = Date.now() + 600;
          busy = false;
          /* The cart PAGE does not re-render on cart:refresh, so a stale line
             would linger visually after we heal it server-side. Reload once
             (guarded against loops) so what's shown matches the cart. The
             drawer path updates live via cart:refresh and never reloads. */
          var guarded = false;
          try { guarded = sessionStorage.getItem('koaEmbReloaded') === '1'; } catch (e) {}
          if (opts.reloadIfChanged && onCartPage() && !guarded) {
            try { sessionStorage.setItem('koaEmbReloaded', '1'); } catch (e) {}
            location.reload();
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('cart:change', function () { reconcile(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reconcile({ reloadIfChanged: true }); });
  } else {
    reconcile({ reloadIfChanged: true });
  }
})();

/* KOA — product gallery position counter (snippets/product-gallery.liquid).
   Replaces the mobile page dots (one 6px button per image — 23 on the One
   Pocket Top, every one failing Lighthouse target-size) with "3 / 23".
   Reads the carousel's own state rather than counting DOM nodes: `cells` is
   its visible (non-hidden) slides, so the total stays right when variant media
   filtering hides images, and carousel:change carries the new index into that
   same list. Liquid renders the correct starting values, so this only corrects
   them as the shopper swipes or picks a colour. */
(function () {
  if (customElements.get('koa-gallery-counter')) return;

  customElements.define('koa-gallery-counter', class extends HTMLElement {
    connectedCallback() {
      this.carousel = document.getElementById(this.getAttribute('aria-controls'));
      this.currentEl = this.querySelector('[data-current]');
      this.totalEl = this.querySelector('[data-total]');
      if (!this.carousel || !this.currentEl || !this.totalEl) return;

      var self = this;
      this.controller = new AbortController();
      var opts = { signal: this.controller.signal };
      this.carousel.addEventListener('carousel:change', function (e) {
        self.update(e.detail ? e.detail.index : undefined);
      }, opts);
      this.carousel.addEventListener('carousel:filter', function () { self.update(); }, opts);

      var name = this.carousel.localName;
      if (name.indexOf('-') > 0) {
        customElements.whenDefined(name).then(function () { self.update(); });
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    update(index) {
      var cells = this.carousel.cells;
      if (!cells || !cells.length) return;
      var i = typeof index === 'number' ? index : this.carousel.selectedIndex;
      if (typeof i !== 'number' || i < 0) i = 0;
      this.totalEl.textContent = cells.length;
      this.currentEl.textContent = Math.min(i + 1, cells.length);
    }
  });
})();
